module.exports = __webpack_public_path__ + "img/3.218e8384.svg";